import { useClientContext } from 'context/ClientContext';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import reactSelect from 'react-select';
import { useCampaignContext } from 'context/CampaignContext';
import { DashboardTypes } from 'API';
import { NavLink } from 'components/Aside/Aside';

interface BarProps {
  location: string;
}

const BarContainer = styled.div<BarProps>`
  display: flex;
  border-radius: 20px;
  justify-content: space-between;
  align-items: center;
  width: 70vw;
  margin: 0 auto 1rem auto;
  padding: ${(props) => (props.location === 'home' ? '0' : '1.5rem 2.5rem')};
  background: ${({ theme }) => theme.placeholderBackground};
  border: 1px solid ${({ theme }) => theme.border};
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .logodiv {
    cursor: pointer;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0.75rem;
    border-radius: 12px;
    transition: all 0.2s ease;

    &:hover {
      background: ${({ theme }) => theme.background};
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateY(-1px);
    }

    .logo {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .log {
    font-size: 35px;
  }

  Select {
    color: ${({ theme }) => theme.primaryGray};
    option {
      color: ${({ theme }) => theme.primaryGray};
      background-color: ${({ theme }) => theme.placeholderBackground};
    }
  }

  .test {
    width: 2.5vw;
    height: 2.5vw;
  }
`;

export const CustomSelect = styled(reactSelect)`
  position: relative;
  display: block;
  width: 350px;
  margin-bottom: 4px;
  font-size: 0.9rem;
  font-family: 'FontRegular', sans-serif;
  font-weight: 400;
  color: ${({ theme }) => theme.primaryGray};
  background: ${({ theme }) => theme.placeholderBackground};

  .react-select__menu {
    background-color: ${({ theme }) => theme.placeholderBackground} !important;
    font-size: 0.85rem;
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }

  .react-select__menu-list::-webkit-scrollbar {
    width: 6px;
  }

  .react-select__menu-list::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.placeholderBackground};
    border-radius: 3px;
  }

  .react-select__menu-list::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.border};
    border-radius: 3px;
    transition: background 0.2s ease;
  }

  .react-select__menu-list::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.secondaryGray};
  }

  .react-select__control {
    background-color: ${({ theme }) => theme.background} !important;
    color: ${({ theme }) => theme.primaryGray} !important;
    border: 1px solid ${({ theme }) => theme.border} !important;
    border-radius: 12px !important;
    min-height: 44px;
    transition: all 0.2s ease;
    box-shadow: none !important;

    &:hover {
      border-color: ${({ theme }) => theme.secondaryGray} !important;
    }
  }

  .react-select__single-value {
    color: ${({ theme }) => theme.primaryGray} !important;
    font-weight: 500;
  }

  .react-select__value-container {
    padding: 0 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    color: ${({ theme }) => theme.secondaryGray};
    transition: all 0.2s ease;

    &:hover {
      color: ${({ theme }) => theme.primaryGray};
    }
  }

  .react-select__control--is-focused {
    border-color: ${({ theme }) => theme.primaryGray} !important;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05) !important;
  }

  .react-select__control--menu-is-open {
    border-color: ${({ theme }) => theme.primaryGray} !important;
  }

  .react-select__option {
    padding: 0.75rem 1rem;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.background};
    }
  }

  .react-select__option--is-selected {
    background-color: ${({ theme }) => theme.primaryGray} !important;
    color: white !important;
  }

  .react-select__input-container {
    color: ${({ theme }) => theme.primaryGray} !important;
  }

  .react-select__placeholder {
    color: ${({ theme }) => theme.secondaryGray};
  }
`;

type Props = {
  setSearchParams(params: any): any;
  searchParams: any;
  location: string;
};

const Bar = (props: Props) => {
  const { setActiveOrganization, activeOrganization, organizationList } = useClientContext();
  const { setDashType } = useCampaignContext();
  useEffect(() => {
    if (activeOrganization) {
      props.setSearchParams({ client: activeOrganization.OrganizationId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOrganization]);

  const clientsDropdown = organizationList?.map((e) => {
    return {
      label: e?.Organization,
      value: e?.OrganizationId,
    };
  });

  const LogoImage = ({ theme }: { theme: string }) => (
    <img
      style={{ width: '70%' }}
      className="bar__clientLogo"
      src={require(`../../assets/${theme}${REACT_APP_LOGO}`)}
      alt="Logo"
    />
  );

  const handleSelection = (value: any) => {
    if (activeOrganization) props.setSearchParams({ client: activeOrganization.OrganizationId });
    const findOrg = organizationList.find((element) => element?.OrganizationId === value);
    setActiveOrganization(findOrg);
  };
  const redirectHome = () => {
    setDashType(DashboardTypes.HOME);
    setActiveOrganization(undefined);
  };
  const { REACT_APP_LOGO } = process.env;

  return (
    <BarContainer location={props.location}>
      <div className="logodiv" onClick={() => redirectHome()}>
        <NavLink to="/">
          <div className="logo">
            <LogoImage theme="light" />
          </div>
        </NavLink>
      </div>

      <CustomSelect
        onChange={(sel: any) => handleSelection(sel.value)}
        options={clientsDropdown}
        defaultValue={clientsDropdown.find((e: any) => e.value === activeOrganization?.OrganizationId)}
        value={clientsDropdown.find((e: any) => e.value === activeOrganization?.OrganizationId)}
        className="react-select-container"
        classNamePrefix="react-select"
      ></CustomSelect>
    </BarContainer>
  );
};

export default Bar;
